<template>
  <el-dialog
    :close-on-click-modal="false"
    title="问题反馈"
    :visible.sync="visible"
    width="800px"
    class="auditOrder"
    :before-close="handleClose"
  >
    <el-form :rules="rules" :model="form" ref="form" label-width="166px">
      <el-form-item prop="name" label="您的称呼：">
        <el-input v-model="form.name" class="input" size="small" />
      </el-form-item>
      <el-form-item prop="phone" label="联系方式：">
        <el-input v-model="form.phone" class="input" size="small" />
      </el-form-item>
      <el-form-item prop="description" label="您的需求或者问题描述：">
        <el-input
          v-model="form.description"
          class="input"
          size="small"
          type="textarea"
          :rows="5"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">关闭</el-button>
      <el-button type="primary" @click="sure" size="small">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addQuestion } from "@/api/sysSupport/question"

export default {
  name: "AuditOrder",
  data() {
    return {
      form: {
        name: "",
        phone: "",
        description: "",
      },
      rules: {
        name: [{ required: true, message: "请选择您的称呼", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        description: [
          { required: true, message: "请输入问题与建议描述 ", trigger: "blur" },
        ],
      },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form = {
          name: "",
          phone: "",
          description: "",
        }
      }
    },
  },
  methods: {
    sure() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          addQuestion({
            questionTitle: this.form.name + "，" + this.form.phone,
            questionContent: this.form.description,
          }).then((response) => {
            if (response.code == "200") {
              this.$message.success("提交成功！")
              this.$emit("onClose")
            } else {
              this.$message.error("新增失败")
            }
          })
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.auditOrder {
  font-size: 12px;
}
.item {
  display: flex;
  flex-wrap: wrap;
}

.tip {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
}

.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}

.blue {
  color: #129ba7;
}
</style>

<style>
.v-modal {
  z-index: 100 !important;
}
</style>
